import { useComputedColorScheme } from '@mantine/core';

export interface ScalePadMarkProps {
  size?: number;
  color?: string;
  decorative?: boolean;
  title?: string;
}

export function ScalePadMark({
  size = 26,
  color,
  decorative = false,
  title = 'ScalePad',
}: ScalePadMarkProps) {
  const colorScheme = useComputedColorScheme('light');
  const resolvedColor = color ?? (colorScheme === 'dark' ? '#FFFFFF' : 'var(--text-primary)');

  return (
    <svg
      viewBox="0 0 1198.6 1198.6"
      width={size}
      height={size}
      role={decorative ? undefined : 'img'}
      aria-label={decorative ? undefined : title}
      aria-hidden={decorative || undefined}
      style={{ flex: '0 0 auto', display: 'inline-block', fill: resolvedColor }}
    >
      {!decorative && <title>{title}</title>}
      <path d="M1125.28 428.5H930.31c-40.26 0-73.32 32.63-73.32 73.32v194.96c0 40.27 32.64 73.33 73.32 73.33h194.97c40.26 0 73.32-32.64 73.32-73.33V501.82c-.42-40.69-33.06-73.32-73.32-73.32Z" />
      <path d="M1125.28 0H930.31c-40.26 0-73.32 32.64-73.32 73.32v194.97c0 40.26 32.64 73.32 73.32 73.32h194.97c40.26 0 73.32-32.63 73.32-73.32V73.32C1198.18 32.64 1165.54 0 1125.28 0Z" />
      <path d="M1125.28 856.99H930.31c-40.26 0-73.32 32.64-73.32 73.32v194.97c0 40.26 32.64 73.32 73.32 73.32h194.97c40.26 0 73.32-32.63 73.32-73.32V930.31c-.42-40.68-33.06-73.32-73.32-73.32Z" />
      <path d="M268.29 856.99H73.32C33.06 856.99 0 889.63 0 930.31v194.97c0 40.26 32.64 73.32 73.32 73.32h194.97c40.26 0 73.32-32.63 73.32-73.32V930.31c-.42-40.68-33.06-73.32-73.32-73.32Z" />
      <path d="M696.78 856.99H501.82c-40.26 0-73.32 32.64-73.32 73.32v194.97c0 40.26 32.63 73.32 73.32 73.32h194.96c40.27 0 73.33-32.63 73.33-73.32V930.31c-.43-40.68-33.06-73.32-73.33-73.32Z" />
      <path d="M696.78 428.5H501.82c-40.26 0-73.32 32.63-73.32 73.32v194.96c0 40.27 32.63 73.33 73.32 73.33h194.96c40.27 0 73.33-32.64 73.33-73.33V501.82c-.43-40.69-33.06-73.32-73.33-73.32Z" />
    </svg>
  );
}
